/**
 * 代登录会话判定（2026-10-23 · spec §13.9 持卡人轨；对齐 agent/merchant 门户同名单判定源）：
 * - 第一真源：session 顶层 impersonated（/portal-login 落地页写入，persist 于 sessionStorage）
 * - 回落：me.impersonated（契约 §0.4：/auth/me 响应末位字段）
 * 两者任一为 true 即视为代登录会话；普通会话两处均为 falsy，恒返回 false（门禁不放松）。
 *
 * 注意：本模块保持零依赖（结构化类型，不 import client.ts），
 * 以便 node --experimental-strip-types 纯逻辑测试直接加载（client.ts 顶层使用 import.meta.env）。
 */

/** 可判定的会话最小结构（对齐 CardholderSession / PortalSessionView 的相关字段子集） */
type ImpersonationCheckable = {
  impersonated?: boolean;
  me?: { impersonated?: boolean } | null;
};

/** 是否为运营代登录会话（顶层优先，me 回落；无会话 / 普通会话均 false） */
export function isImpersonatedSession(session: ImpersonationCheckable | null): boolean {
  return session?.impersonated === true || session?.me?.impersonated === true;
}
